import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { FullScreenLoadingState } from "@/components/PageStates";

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <FullScreenLoadingState />;
  }

  return user ? children : <Navigate to="/login" replace />;
};

export default PrivateRoute;
